import { getAxiosInstance } from './axiosInstance';
import { useGlobalErrorHandler } from './useGlobalErrorHandler';
import { useAppContext } from '@context/AppContext';

export const useInstitutionsService = () => {
    const handleUnauthorized = useGlobalErrorHandler();
    const appState = useAppContext().state;

    const getInstitutions = async (): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.get('/institutions?page=1&limit=1000000');
        return data;
    };

    const getInstitution = async ( idItem: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.get(`/institutions/${idItem}`);
        return data;
    };
    
    const putInstitution = async ( idItem: any , params: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.put(`/institutions/${idItem}` , params );
        return data;
    };

    const postInstitution = async ( params: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.post(`/institutions` , params );
        return data;
    };

    const getInstitutionServices = async ( idInstitution: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.get(`/institutions/${idInstitution}/services`);
        return data;
    };

    const getAllProtocols = async ( idInstitution: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.get(`/institutions/${idInstitution}/with-protocols-drugs`);
        return data;
    };

    const postRelationProtocol = async ( idInstitution: any , params: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.post(`/institutions/${idInstitution}/with-protocols-drugs` , params );
        return data;
    };

    const deleteRelationProtocolDrug = async ( idInstitution: any , params: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.delete(`/institutions/${idInstitution}/with-protocols-drugs` , {data: params} );
        return data;
    };

    const getAllDrugsInst = async ( idInstitution: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.get(`/institutions/${idInstitution}/with-drugs`);
        return data;
    };

    const putAllDrugsInst = async ( idInstitution: any , params: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.put(`/institutions/${idInstitution}/with-drugs`,params);
        return data;
    };

    const getPathologiesFull = async ( idInstitution: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.get(`/institutions/${idInstitution}/with-pathologies-protocol-drugs`);
        return data;
    };

    const getInfusionSet = async ( idInstitution: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.get(`/institutions/${idInstitution}/with-infusion-set`);
        return data;
    };

    const putInfusionSet = async ( idInstitution: any , params: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.put(`/institutions/${idInstitution}/with-infusion-set` , params );
        return data;
    };

    const getSolutions = async ( idInstitution: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.get(`/institutions/${idInstitution}/solutions`);
        return data;
    };

    const getAdministrationRoutes = async ( idInstitution: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.get(`/institutions/${idInstitution}/administration-routes`);
        return data;
    };

    const getInfoDrug = async ( idDrug: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.get(`/drugs/detail/${idDrug}`);
        return data;
    };

    const getAllInstitutions = async ( ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.get(`/institutions`);
        return data;
    };

    const getTime = async ( idInstitution: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.get(`/institutions-schedule/${idInstitution}/schedule-time/Reception`);
        return data;
    };

    const getMixingCenter = async ( idInstitution: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.get(`/institutions/${idInstitution}/with-mixing-center`);
        return data;
    };
    const putMixingCenter = async ( idInstitution: any , params: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.put(`/institutions/${idInstitution}/with-mixing-center`,params);
        return data;
    };

    const getScheduleTime = async ( idInstitution: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.get(`/institutions-schedule/${idInstitution}/all-schedules`);
        return data;
    };

    const postScheduleTime = async ( params: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.post(`/institutions-schedule/` , params );
        return data;
    };

    const putScheduleTime = async ( idAlgo: any , params: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.put(`/institutions-schedule/${idAlgo}` , params );
        return data;
    };

    return {
        getInstitutions ,
        getInstitution ,
        putInstitution ,
        postInstitution ,
        getInstitutionServices ,
        getAllProtocols ,
        postRelationProtocol ,
        getAllDrugsInst ,
        putAllDrugsInst ,
        getPathologiesFull ,
        getInfusionSet ,
        getSolutions ,
        getAdministrationRoutes ,
        getInfoDrug ,
        getAllInstitutions ,
        getTime ,
        getMixingCenter ,
        putMixingCenter ,
        putInfusionSet ,
        deleteRelationProtocolDrug ,
        getScheduleTime ,
        postScheduleTime ,
        putScheduleTime
    };
}